import { motion } from "framer-motion";
import { PROCESS_STEPS } from "@/data/content";

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="relative py-32 lg:py-44 px-6 lg:px-24 bg-ink2">
      <div className="max-w-[1600px] mx-auto grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <p className="font-mono text-[10px] tracking-[0.35em] text-goldw uppercase mb-6">Chapter 05 — Process</p>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-ivory leading-[1.05]" data-testid="process-headline">
              From First Call<br />to <span className="italic text-goldw">Final Key</span>
            </h2>
            <p className="mt-6 text-sm sm:text-base text-zinc2 leading-relaxed max-w-sm">
              Six stages, one accountable team. You always know where your project stands —
              and what happens next.
            </p>
          </div>
        </div>

        <div className="lg:col-span-8 relative">
          <motion.div
            initial={{ scaleY: 0 }}
            whileInView={{ scaleY: 1 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 2, ease: "easeInOut" }}
            className="absolute left-[27px] top-2 bottom-2 w-px bg-goldw/25 origin-top hidden sm:block"
            aria-hidden="true"
          />
          <div className="space-y-14">
            {PROCESS_STEPS.map((s, i) => (
              <motion.div
                key={s.num}
                initial={{ opacity: 0, x: 32 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                data-testid={`process-step-${s.num}`}
                className="relative flex gap-6 sm:gap-10"
              >
                <div className="hidden sm:flex flex-col items-center">
                  <span className="relative z-10 flex items-center justify-center w-14 h-14 border border-goldw/40 bg-ink2 font-mono text-xs text-goldw tracking-[0.15em]">
                    {s.num}
                  </span>
                </div>
                <div className="pb-2 border-b border-white/8 flex-1">
                  <span className="sm:hidden font-mono text-[10px] text-goldw tracking-[0.2em]">{s.num} — </span>
                  <h3 className="font-serif font-light text-2xl sm:text-3xl text-ivory inline sm:block">{s.title}</h3>
                  <p className="mt-3 text-sm sm:text-base text-zinc2 leading-relaxed max-w-xl">{s.copy}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
